module.exports = __webpack_public_path__ + "img/plano-individual.88e2c8e6.jpeg";